import type { RouteRecordRaw } from 'vue-router'

const shippingRoutes: RouteRecordRaw[] = [
  {
    path: 'shipping/settings',
    component: () => import('@/pages/shipping/settings/layout.vue'),
    meta: { title: '发货基础设置', requiresPsi: true },
    children: [
      {
        path: '',
        redirect: '/shipping/settings/api-config',
      },
      {
        path: 'carriers',
        name: 'ShippingCarriers',
        component: () => import('@/pages/shipping/settings/carriers.vue'),
        meta: { title: '快递公司' },
      },
      {
        path: 'api-config',
        name: 'ShippingApiConfig',
        component: () => import('@/pages/shipping/settings/apiConfig.vue'),
        meta: { title: '快递接口' },
      },
      {
        path: 'project-sender-info',
        name: 'ShippingProjectSenderInfo',
        component: () => import('@/pages/shipping/settings/projectSenderInfo.vue'),
        meta: { title: '发件人' },
      },
      {
        path: 'sender-info',
        name: 'ShippingSenderInfo',
        component: () => import('@/pages/shipping/settings/senderInfo.vue'),
        meta: { title: '发件人' },
      },
    ],
  },
]

export default shippingRoutes
